<ng-template #tableQrSectionTpl let-form="form">
    <upp-form-section *ngIf="ShowTableQr" fill="clear">
        <div class="table-qr-wrapper">
            <div class="table-qr-image-box">
                <img uppDataid="tableedit-qrcode-image" [src]="TableQrDataUrl" [alt]="tr('@place_table_qrcode_what', [ table?.number ])">
            </div>
            <p class="table-qr-text">{{tr('@place_table_qrcode_what', [ table?.number ])}}</p>
            <ion-button uppDataid="tableedit-qrcode-download"
                size="large"
                expand="block"
                color="primary"
                fill="outline"
                (click)="DownloadTableQr()"
            >
                {{tr('@place_table_qrcode_download')}}
            </ion-button>
        </div>
    </upp-form-section>
</ng-template>

<ng-template #tableInfoSectionTpl let-form="form">
    <ng-container [formGroup]="form">
        <upp-form-section title="{{tr('@place_table_display_info')}}" class="table-info-section">
            <ion-item lines="full">
                <upp-input uppDataid="tableedit-alias-input"
                    formControlName="alias"
                    type="text"
                    placeholder="{{tr('@place_table_input_alias_ph')}}"
                    title="{{tr('@place_table_input_alias')}}"
                ></upp-input>
            </ion-item>

            <ion-item lines="full">
                <upp-input uppDataid="tableedit-chairs-input"
                    formControlName="chairs"
                    type="number"
                    placeholder="{{tr('@place_table_display_chairs_ph')}}"
                    title="{{tr('@place_table_display_chairs')}}"
                    [errornfo]="{
                        required: tr('@mandatory_field'),
                        min: tr('@numrange_field', [ TableChairsMin, TableChairsMax ]),
                        max: tr('@numrange_field', [ TableChairsMin, TableChairsMax ])
                    }"
                ></upp-input>
            </ion-item>
        </upp-form-section>

        <upp-form-section *ngIf="ShowAreas" title="{{tr('@place_table_areas_section')}}" fill="solid" class="table-areas-section">
            <ion-item *ngIf="ShowDraw" lines="full" class="table-edit-field-selector">
                <upp-select uppDataid="tableedit-floorarea-select" class="table-edit-select-host" formControlName="area" title="{{tr('@place_table_area_local')}}">
                    <upp-select-item>
                        <ion-item lines="none" button>
                            <ion-label class="table-edit-field-value">{{form.get('area')?.value?.text}}</ion-label>
                        </ion-item>
                    </upp-select-item>
                    <upp-select-list>
                        <upp-select-option *ngFor="let option of AreaOptions; trackBy: OptionTrack" [value]="option" [uppDataid]="'tableedit-floorarea-opt-' + option.text">
                            <ion-item lines="none" button>
                                <ion-label>{{option.text}}</ion-label>
                            </ion-item>
                        </upp-select-option>
                    </upp-select-list>
                </upp-select>
            </ion-item>

            <ion-item *ngIf="ShowPrices" lines="full" class="table-edit-field-selector" [style.margin-top]="ShowDraw ? '12px' : null">
                <upp-select uppDataid="tableedit-pricezone-select" class="table-edit-select-host" formControlName="price" title="{{tr('@place_table_area_price_zone')}}">
                    <upp-select-item>
                        <ion-item lines="none" button>
                            <ion-label class="table-edit-field-value">{{form.get('price')?.value?.text ?? tr('@place_table_price_zone_default')}}</ion-label>
                        </ion-item>
                    </upp-select-item>
                    <upp-select-list>
                        <upp-select-option uppDataid="tableedit-pricezone-opt-default" [value]="null">
                            <ion-item lines="none" button>
                                <ion-label>{{tr('@place_table_price_zone_default')}}</ion-label>
                            </ion-item>
                        </upp-select-option>
                        <upp-select-option *ngFor="let option of PriceOptions; trackBy: OptionTrack" [value]="option" [uppDataid]="'tableedit-pricezone-opt-' + option.text">
                            <ion-item lines="none" button>
                                <ion-label>{{option.text}}</ion-label>
                            </ion-item>
                        </upp-select-option>
                    </upp-select-list>
                </upp-select>
            </ion-item>

            <ion-item *ngIf="ShowTills" lines="full" class="table-edit-field-selector" [style.margin-top]="(ShowDraw || ShowPrices) ? '12px' : null">
                <upp-select uppDataid="tableedit-till-select" class="table-edit-select-host" formControlName="till" title="{{tr('@place_table_area_till')}}">
                    <upp-select-item>
                        <ion-item lines="none" button>
                            <ion-label class="table-edit-field-value">{{form.get('till')?.value?.text ?? tr('@place_table_select_one')}}</ion-label>
                        </ion-item>
                    </upp-select-item>
                    <upp-select-list>
                        <upp-select-option *ngFor="let option of TillOptions; trackBy: OptionTrack" [value]="option" [uppDataid]="'tableedit-till-opt-' + option.text">
                            <ion-item lines="none" button>
                                <ion-label>{{option.text}}</ion-label>
                            </ion-item>
                        </upp-select-option>
                    </upp-select-list>
                </upp-select>
            </ion-item>
        </upp-form-section>
    </ng-container>
</ng-template>

<ng-template #tableAttentionTpl>
    <div class="table-attention">
        <div class="table-attention-order">
            <ion-button uppDataid="tableview-ticket-button"
                size="large"
                expand="block"
                [color]="view.LightTheme ? 'dark' : 'warning'"
                fill="outline"
                (click)="OnPlaceOrder()"
            >
                {{tr('@place_table_placeorder')}}
            </ion-button>
        </div>

        <ion-card uppDataid="tableview-attention-card" class="table-attention-card" [color]="view.LightTheme ? 'warning' : 'light'">
            <ion-icon [color]="view.LightTheme ? 'dark' : 'warning'" name="hand-right-outline"></ion-icon>
            <ion-card-title [color]="view.LightTheme ? 'dark' : 'warning'">
                {{tr('@place_table_warning')}}
            </ion-card-title>
        </ion-card>

        <div uppDataid="tableview-requests-info" *ngIf="Requests.length > 0">
            <ion-item class="table-attention-title" lines="none">
                <ion-label>{{tr('@place_table_actions')}}</ion-label>
            </ion-item>
            <ion-list>
                <ion-item *ngFor="let request of Requests; trackBy: RequestTrack"
                    uppDataid="tableview-ticket-show"
                    class="table-attention-action"
                    (click)="OnShowTicket(request.ticket)"
                >
                    <ng-container *ngIf="request.reason == null">
                        <ion-icon slot="start" name="hand-right-outline"></ion-icon>
                        <ion-label>
                            {{tr('@waiter_request_client_actions')}}<br/>
                            <span class="small">{{RequestElapsed(request)}}</span>
                        </ion-label>
                    </ng-container>

                    <ng-container *ngIf="request.reason === 'REFUND'">
                        <ion-icon slot="start" name="arrow-undo-circle-outline"></ion-icon>
                        <ion-label>
                            {{tr('@waiter_request_reason_refund')}}<br/>
                            <span class="small">{{RequestElapsed(request)}}</span>
                        </ion-label>
                        <ion-label class="price" slot="end" *ngIf="RequestAmount(request) as amount">
                            {{amount.Int}},<span class="small">{{amount.Dec}}</span>{{tr('@currency')}}
                        </ion-label>
                    </ng-container>

                    <ng-container *ngIf="request.reason === 'PAYCARD'">
                        <ion-icon slot="start" name="card-outline"></ion-icon>
                        <ion-label>
                            {{tr('@waiter_request_reason_paycard')}}<br/>
                            <span class="small">{{RequestElapsed(request)}}</span>
                        </ion-label>
                        <ion-label class="price" slot="end" *ngIf="request.ticket">
                            {{request.ticket.priceinfo.int}},<span class="small">{{request.ticket.priceinfo.dec}}</span>{{tr('@currency')}}
                        </ion-label>
                    </ng-container>

                    <ng-container *ngIf="request.reason === 'PAYCASH'">
                        <ion-icon slot="start" name="cash-outline"></ion-icon>
                        <ion-label>
                            {{tr('@waiter_request_reason_paycash')}}<br/>
                            <span class="small">{{RequestElapsed(request)}}</span>
                        </ion-label>
                        <ion-label class="price" slot="end" *ngIf="request.ticket">
                            {{request.ticket.priceinfo.int}},<span class="small">{{request.ticket.priceinfo.dec}}</span>{{tr('@currency')}}
                        </ion-label>
                    </ng-container>
                </ion-item>
            </ion-list>
        </div>

        <div uppDataid="tableview-pending-info" *ngIf="Pending.length > 0">
            <ion-item class="table-attention-title" lines="none">
                <ion-label>{{tr('@place_table_pending')}}</ion-label>
            </ion-item>
            <ion-list>
                <ion-item *ngFor="let pending of Pending; trackBy: PendingTrack"
                    uppDataid="tableview-ticket-thumb"
                    class="table-attention-action"
                    (click)="OnShowTicket(pending)"
                >
                    <ion-label>
                        #{{pending.orderno}}<br/>
                        <span class="small">{{TicketElapsed(pending)}}</span>
                    </ion-label>
                    <ion-label class="price" slot="end">
                        {{pending.priceinfo.int}},<span class="small">{{pending.priceinfo.dec}}</span>{{tr('@currency')}}
                    </ion-label>
                </ion-item>
            </ion-list>
        </div>

        <div class="table-attention-brief" uppDataid="tableview-brief-info" *ngIf="!Brief.isgeneric">
            <ion-item lines="none">
                <ion-label>{{tr('@place_table_brief_title')}}</ion-label>
            </ion-item>
            <ion-list uppDataid="tablebrief-info">
                <ion-item uppDataid="tablebrief-income-info" color="warning" class="title cover" [lines]="((Brief.torefund) && (Brief.pending == 0)) ? 'none' : 'full'">
                    <ion-label>
                        <span *ngIf="Brief.torefund">{{tr('@place_table_to_refund')}}</span>
                        <span *ngIf="!Brief.torefund">{{tr('@place_table_to_income')}}</span>
                    </ion-label>
                    <ion-label slot="end" class="price">
                        {{Brief.amount.toFixed(2)}}{{tr('@currency')}}
                    </ion-label>
                </ion-item>
                <ion-item uppDataid="tablebrief-income-pending" [hidden]="Brief.pending == 0" lines="none">
                    <ion-label>{{tr('@place_table_income_pending')}}</ion-label>
                    <ion-label slot="end" class="price">{{Brief.pending.toFixed(2)}}{{tr('@currency')}}</ion-label>
                </ion-item>
                <ion-item uppDataid="tablebrief-refund-pending" [hidden]="Brief.refund == 0" lines="none">
                    <ion-label>{{tr('@place_table_refund_pending')}}</ion-label>
                    <ion-label slot="end" class="price">{{Brief.refund.toFixed(2)}}{{tr('@currency')}}</ion-label>
                </ion-item>
                <ion-item uppDataid="tablebrief-paycash-info" *ngIf="Brief.paycash != 0">
                    <ion-label>{{tr('@place_table_paycash')}}</ion-label>
                    <ion-label slot="end" class="price">{{Brief.paycash.toFixed(2)}}{{tr('@currency')}}</ion-label>
                </ion-item>
                <ion-item uppDataid="tablebrief-cashchange-given" class="cashchange" *ngIf="Brief.givechange != 0">
                    <ion-label color="medium">{{tr('@place_table_cashgiven')}}</ion-label>
                    <ion-label slot="end" color="medium" class="price">{{Brief.givechange.toFixed(2)}}{{tr('@currency')}}</ion-label>
                </ion-item>
                <ion-item uppDataid="tablebrief-cashchange-back" class="cashchange" *ngIf="Brief.backchange != 0">
                    <ion-label color="medium">{{tr('@place_table_cashreturn')}}</ion-label>
                    <ion-label slot="end" color="medium" class="price">{{Brief.backchange.toFixed(2)}}{{tr('@currency')}}</ion-label>
                </ion-item>
                <ion-item uppDataid="tablebrief-paycard-info" *ngIf="Brief.paycard != 0">
                    <ion-label>{{tr('@place_table_paycard')}}</ion-label>
                    <ion-label slot="end" class="price">{{Brief.paycard.toFixed(2)}}{{tr('@currency')}}</ion-label>
                </ion-item>
            </ion-list>
        </div>
    </div>
</ng-template>

<upp-visible-control mode="fill">
    <upp-panel *ngIf="table" [size]="view.Mobile ? 'auto' : 'large'">
        <upp-panel-header>
            <upp-header color="warning" lines="light" menu="hide">
                <upp-header-title>
                    <span *ngIf="table.alias">{{table.alias}}</span>
                    <span *ngIf="!table.alias">{{tr('@place_table_number', [ table.number ])}}</span>
                </upp-header-title>
                <upp-header-button uppDataid="tableedit-close-button" (click)="CancelChanges()">
                    <ion-icon name="close-outline"></ion-icon>
                </upp-header-button>
            </upp-header>
        </upp-panel-header>
        <upp-panel-content>
            <upp-form *ngIf="Attention" layout="fill">
                <ng-container *ngTemplateOutlet="tableAttentionTpl"></ng-container>

                <upp-form-buttons>
                    <ion-button uppDataid="tableview-attended-done"
                        size="large"
                        expand="block"
                        color="warning"
                        (click)="RequestDone()"
                    >
                        {{tr('@place_table_attended_done')}}
                    </ion-button>
                    <ion-button uppDataid="tableview-attended-wait"
                        expand="block"
                        fill="clear"
                        [color]="view.LightTheme ? 'dark' : 'warning'"
                        (click)="CancelChanges()"
                    >
                        {{tr('@place_table_attended_wait')}}
                    </ion-button>
                </upp-form-buttons>
            </upp-form>

            <upp-form *ngIf="!Attention && TableForm as tableForm" layout="fill" [formGroup]="tableForm">
                <ng-container *ngTemplateOutlet="tableQrSectionTpl; context: { form: tableForm }"></ng-container>
                <ng-container *ngTemplateOutlet="tableInfoSectionTpl; context: { form: tableForm }"></ng-container>

                <upp-form-buttons>
                    <ion-button uppDataid="tableedit-submit-button"
                        size="large"
                        expand="block"
                        color="primary"
                        [disabled]="!CanAcceptChanges"
                        (click)="AcceptChanges()"
                    >
                        {{tr('@place_table_qrcode_accept')}}
                    </ion-button>
                    <ion-button uppDataid="tableedit-cancel-button"
                        expand="block"
                        fill="clear"
                        color="primary"
                        (click)="CancelChanges()"
                    >
                        {{tr('@place_table_qrcode_cancel')}}
                    </ion-button>
                </upp-form-buttons>
            </upp-form>
        </upp-panel-content>
    </upp-panel>
</upp-visible-control>
